if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						weightDisplay = this.querySelector('.product-quantity__weight-display'),
                        totalDisplay = this.querySelector('.product-quantity__total-display'),
						isWeightProduct = this.hasAttribute('data-weight-product'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

	const updateWeightDisplay = () => {

	if ( isWeightProduct ) {

		const quantity = parseInt(qty.value) || 1;

		if ( weightDisplay ) {

			const kilos = (quantity * 0.1).toFixed(3).replace('.', ',');

			weightDisplay.textContent = kilos + ' kg';

		}

		if ( totalDisplay ) {

			const unitPrice = parseInt(totalDisplay.dataset.unitPrice, 10) || 0;
			const total = (quantity * unitPrice) / 100;

			const formattedTotal = total.toLocaleString('es-CR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});

			totalDisplay.textContent = 'Total: ₡ ' + formattedTotal;

		}

	}

};

			const updateButtons = () => {

				const currentQty = parseInt(qty.value) || qtyMin;

				if ( currentQty <= qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}

				if ( currentQty >= qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}

			};

			updateButtons();
			updateWeightDisplay();

			qty.addEventListener('change', (e)=>{

				let currentQty = parseInt(qty.value) || qtyMin;

				currentQty = Math.max(qtyMin, Math.min(currentQty, qtyMax));

				qty.value = currentQty;

				updateButtons();
				updateWeightDisplay();

			});

			qtyMinus.addEventListener('click', (e)=>{

				e.preventDefault();

				if ( qtyMinus.classList.contains('disabled') ) {
					return;
				}

				const currentQty = parseInt(qty.value) || qtyMin;

				if ( currentQty > qtyMin ) {

					qty.value = currentQty - 1;

					updateButtons();
					updateWeightDisplay();

					qty.dispatchEvent(new Event('change', { bubbles: true }));

				}

			});

			qtyPlus.addEventListener('click', (e)=>{

				e.preventDefault();

				if ( qtyPlus.classList.contains('disabled') ) {
					return;
				}

				const currentQty = parseInt(qty.value) || qtyMin;

				if ( currentQty < qtyMax ) {

					qty.value = currentQty + 1;

					updateButtons();
					updateWeightDisplay();

					qty.dispatchEvent(new Event('change', { bubbles: true }));

				}

			});

		}
		
	}

	if ( typeof customElements.get('product-quantity') === 'undefined' ) {
		customElements.define('product-quantity', ProductQuantity);
	}

}